import { generatePath, useMatch } from "react-router-dom";
import { TabNavBar } from "src/components/atoms/TabNavBar/TabNavBar";
import * as Team from "src/state/modules/team";
import * as Event from "src/state/modules/event";
import { ROUTES } from "src/utils/constants/routes";
import { SABERTOOTH_ENABLED } from "src/utils/sabertooth-client";
import cn from "classnames";
import Styles from "./EventNavBar.module.scss";

interface EventNavBarProps {
  team: Team.Team;
  event: Event.Event;
  isFinal: boolean;
}

export default function EventNavBar({ team, event, isFinal }: EventNavBarProps) {
  const eventBoxScorePath = generatePath(ROUTES.teams.events.boxScore, { id: team.id, eid: event.id });
  const eventPlaysPath = generatePath(ROUTES.teams.events.plays, { id: team.id, eid: event.id });
  const eventStatsPath = generatePath(ROUTES.teams.events.gameStats, { id: team.id, eid: event.id });
  const eventVideosPath = generatePath(ROUTES.teams.events.videos, { id: team.id, eid: event.id });
  const eventInfoPath = generatePath(ROUTES.teams.events.scheduleEvent, { id: team.id, eid: event.id });

  const teamNavOptions = [
    {
      label: "Box Score",
      path: eventBoxScorePath,
      active: useMatch({ path: eventBoxScorePath, end: true }) !== null,
      "data-testid": "event-nav-bar-box",
      isShowing: isFinal && SABERTOOTH_ENABLED,
      isEvent: true,
    },
    {
      label: "Plays",
      path: eventPlaysPath,
      active: useMatch({ path: eventPlaysPath, end: true }) !== null,
      "data-testid": "event-nav-bar-plays",
      isShowing: isFinal && SABERTOOTH_ENABLED,
      isEvent: true,
    },
    {
      label: "Game Stats",
      path: eventStatsPath,
      active: useMatch({ path: eventStatsPath, end: true }) !== null,
      "data-testid": "event-nav-bar-stats",
      isShowing: isFinal,
      isEvent: true,
    },
    {
      label: "Videos",
      path: eventVideosPath,
      active: useMatch({ path: eventVideosPath, end: true }) !== null,
      "data-testid": "event-nav-bar-videos",
      isShowing: isFinal,
      isEvent: true,
    },
    {
      label: "Info",
      path: eventInfoPath,
      active: useMatch({ path: eventInfoPath, end: true }) !== null,
      "data-testid": "event-nav-bar-info",
      isShowing: true,
      isEvent: true,
    },
  ];
  return (
    <div className={Styles.eventNavBar}>
      <TabNavBar className={cn("")} options={teamNavOptions} />
    </div>
  );
}
